module.exports = __webpack_public_path__ + "static/media/send-button.27e55d46.svg";